export default {
  headerContent: {
    title: 'Bereket Sigorta Zorunlu Deprem Sigortası (DASK) Fiyatları',
    slogan: "Zorunlu Deprem Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'DASK TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Bereket Sigorta DASK',
    description: {
      title:
        'Bereket Sigorta DASK (Zorunlu Deprem Sigortası) Nedir? DASK Ne Demek? ',
      content: [
        'Bereket Sigorta’dan alacağınız zorunlu deprem sigortası ile konutunuza ve kendinize koruma sağlayabilirsiniz.',
        'Dask sigortası, deprem ve deprem sonucu ortaya çıkan yangın ve yer kayması gibi hasarlara karşı sigortalıyı güvence altına almaktadır.'
      ]
    },
    subContent: {
      title: 'DASK Adres Kodu Nedir?',
      content: [
        {
          paragraph:
            '2013 yılında konut adreslerine resmi kimlik verilmeye başlamıştır. Konutun adresinin Uluslar Arası Veri Tabanına kaydı sonucu verilen 10 haneli özel koda adres kodu denmektedir.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'DASK Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'DASK Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'DASK Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Bereket Sigorta DASK Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'DASK Sigorta Bedeli Nedir?',
      content: [
        {
          paragraph:
            'Dask sigortası bina bedeli binanın doğal afet sonucunda yıkılması sonucunda binanın kaba inşaatı için ödenecek bedeli belirtmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Zorunlu Deprem Sigortası ZDS Teminatları Neler?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası genel şartları gereğince sunulan teminatlar;',
          subList: [
            'Deprem sonrası maddi zarar,',
            'Deprem sonrası yangın,',
            'Deprem sonrası infilak,',
            'Deprem sonrası tsunami,',
            'Deprem sonrası yer kaymasından oluşmaktadır.'
          ]
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Zorunlu Deprem Sigortası Teminat Dışı Kalan Haller Nelerdir?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası genel şartları gereğince teminat dışı kalan haller;',
          subList: [
            'Alternatif ikametgah ve işyeri masrafları',
            'Deprem ve deprem sonucu oluşan yangın, infilak, tsunami veya yer kaymasının dışında kalan hasarlar',
            'Depremden bağımsız olarak, binanın kendi kusurlu yapısı nedeniyle zamanla oluşmuş zararlar',
            'Enkaz kaldırma masrafları',
            'Her türlü taşınır mal, eşya ve benzerleri',
            'İş durması',
            'Kar kaybı',
            'Kira mahrumiyeti',
            'Mali sorumluluklar ve benzeri başkaca ileri sürülebilecek diğer bütün dolaylı zararlar',
            'Manevi tazminat talepleri',
            'Tüm bedeni zararlar ve vefat teminatını içerir.'
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta Zorunlu Deprem Sigortası Hangi Bölümleri Kapsar?',
      content: [
        {
          paragraph:
            'Genel şartlarda belirtilmiş binalar hariç tüm binalar kapsam dâhilindedir.',
          subList: null
        },
        {
          paragraph: 'Bu binalar;',
          subList: [
            'Tapuya kayıtlı ve özel mülkiyete tabi taşınmazlar üzerinde mesken olarak inşa edilmiş binalar,',
            '634 sayılı Kat Mülkiyeti Kanunu kapsamındaki bağımsız bölümler,',
            'Bu binaların içinde yer alan ve ticarethane, büro ve benzeri amaçlarla kullanılan bağımsız bölümler,',
            'Doğal afetler nedeniyle devlet tarafından yaptırılan veya verilen kredi ile yapılan meskenler.'
          ]
        },
        {
          paragraph:
            'Zorunlu Deprem Sigortası ayrıca yukarıdaki koşullara uyan;',
          subList: [
            'Kat irtifakı tesis edilmiş binalar,',
            'Tapuda henüz cins tashihi yapılmamış ve tapu kütüğünde vasfı "arsa vs." olarak görünen binalar,',
            'Tapu tahsisi henüz yapılmamış kooperatif evleridir.'
          ]
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Zorunlu Deprem Sigortası Kapsamında Yer Alan Konut Bölümleri Nelerdir?',
      content: [
        {
          paragraph:
            'Deprem sigortası genel şartlarına göre kapsam altında olan bölümler;',
          subList: [
            'Temeller',
            'Ana duvarlar',
            'Bağımsız bölümleri ayıran ortak duvarlar',
            'Bahçe duvarları',
            'İstinat duvarları',
            'Tavan ve tabanlar',
            'Merdivenler',
            'Asansörler',
            'Sahanlıklar',
            'Koridorlar',
            'Çatılar',
            'Bacalar',
            'Yapının yukarıdakilerle benzer nitelikteki tamamlayıcı bölümlerinden oluşmaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta DASK Yaptırma Mecburi Mi?',
      content: [
        {
          paragraph: 'DASK sigortası yaptırmak kanunen zorunludur.',
          subList: null
        }
      ]
    },
    {
      title:
        'Abonelikler İçin Bereket Sigortadan Deprem Sigortası Alabilir Miyim?',
      content: [
        {
          paragraph:
            'Elektrik ve doğalgaz için gerekli olan zorunlu deprem sigortanızı bereket sigortadan satın alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Hangi Binalar Zorunlu Deprem Sigortası Kapsamındadır?',
      content: [
        {
          paragraph:
            'Genel şartlarda belirtilmiş binalar hariç tüm binalar kapsam dâhilindedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Hangi Binalar Genel Şartlar Gereğince Zorunlu Deprem Sigortası Kapsamında Değildir?',
      content: [
        {
          paragraph:
            'Zorunlu Deprem Sigortası kapsamı dışında kalan bina türleri aşağıdaki gibidir:',
          subList: [
            '9/11/1983 tarihli ve 2946 sayılı Kamu Konutları Kanununa tâbi olan veya kamu hizmet binası olarak kullanılan binalar ve bağımsız bölümler,',
            'Köy nüfusuna kayıtlı ve köyde sürekli oturanlarca köy yerleşik alanları ve civarında ve mezralarda yapılan binalar,',
            'Tamamı ticari veya sınai amaçla kullanılan binalar,',
            'Projesi bulunmayan ve mühendislik hizmeti görmemiş binalar,',
            'Taşıyıcı sistemi olumsuz yönde etkileyecek şekilde tadil edildiği veya zayıflatıldığı tespit edilen binalar,',
            'Taşıyıcı sistemi olumsuz yönde etkileyecek şekilde ilgili mevzuata ve projeye aykırı olarak inşa edilen binalar,',
            'Yetkili kamu kurumları tarafından yıkılmasına karar verilen binalar ile mesken olarak kullanıma uygun olmayan, bakımsız, harap veya metruk binalar,',
            'Köy yerleşimleri -genel olarak gelir düzeyinin düşük olması, binalarda belediye denetiminin bulunmaması ve sigortanın sunumunun zor olması gibi nedenlerle- sigorta kapsamı dışında yer alır. Ancak, köylerde bulunan yapılar için istendiği takdirde İhtiyari Deprem Sigortası yaptırılması mümkündür. Benzer şekilde ticari ve sanayi amaçlar için kullanılan binalar için de İhtiyari Deprem Sigortası yaptırılabilir.'
          ]
        }
      ]
    },
    {
      title:
        'Tapu Olmadan Atlas Sigorta Zorunlu Deprem Sigortası Yapılıyor Mu?',
      content: [
        {
          paragraph: 'Tapu olamadan Dask sigortası yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta DASK Yenileme Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Dask poliçenizi poliçe bitiş tarihinden 30 gün önce yenilete bilirsiniz. Dask yenilemenizi mevcutta bulanan poliçenizi veya poliçe numaranızı uzman danışmanlarımıza ileterek deprem sigortanızın yenilemesini yapabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta DASK Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'DASK sigortanızı Bereket Sigorta’dan alokasko ayrıcalığıyla alabilirsiniz. Bunun için alokasko.com üzerinde yer alan başvuru formunu doldurabilir ve online DASK fiyatı alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta DASK (Zorunlu Deprem Sigortası) Ne İşe Yarar?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası, deprem sonucu infilak, yangın gibi risklerin gerçekleşmesi sonucunda meydana çıkan büyük maddi kayıplara karşı sigortalıyı korumaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta DASK İçin Nereye Başvurulur?',
      content: [
        {
          paragraph: 'DASK sigortası için gerekli olan bilgi ve belgeler;',
          subList: [
            'Sigortalının vergi ve T.C. kimlik numarası, ',
            'Sigortalanacak yerin açık adresi, ',
            'Binanın inşa yılı,',
            'Binanın yapı tarzı,',
            'Binanın kaç katlı olduğu, ',
            'Binanın hasar durumu,',
            'Konutun brüt yüz ölçümü (m²), ',
            'Konutun kullanım şeklinden oluşmaktadır.'
          ]
        },
        {
          paragraph:
            'Bu bilgiler sigortacıya doğru ve kesin olarak verilmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta DASK Ödenmezse Ne Olur?',
      content: [
        {
          paragraph: 'Dask sigortası ödeme alınmadan yürürlüğe girmemektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Zorunlu Deprem Sigortasında Tazminat Ödenmesi Ne Şekilde Olur?',
      content: [
        {
          paragraph:
            'Tazminat ödemesi tazminat miktarının belirlenmesinin ardından Doğal Afet Sigortaları Kurumu tarafından poliçede yazan bedeli aşmamak kaydıyla en geç bir ay içerisinde hak sahibine yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta DASK (Zorunlu Deprem Sigortası) İptali Yapılır Mı?',
      content: [
        {
          paragraph: 'Dask sigortası iptal edilemeyen bir sigorta üründür.',
          subList: null
        }
      ]
    },
    {
      title: 'Ev Satışından Sonra Bereket Sigorta DASK İptali Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Ev satışından sonra Dask iptal edilemez ama yeni alan kişinin üzerine aktarılabilir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta DASK (Zorunlu Deprem Sigortası) Hasar İhbarı Nereye Yapılır?',
      content: [
        {
          paragraph:
            'Hasar ihbarınızı isterseniz sigorta şirketlerine veya Alo 125 hattına bildirilebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta DASK Poliçe No Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Poliçe numaranızı dask.gov.tr internet sitesine girerek poliçe sorgulama sekmesinde yer alan bilgileri doldurarak öğrenebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta DASK (Zorunlu Deprem Sigortası) Teklifi Almak İçin Ne Yapılır?',
      content: [
        {
          paragraph:
            'Dask sigortası teklifi almak için gerekli bilgileri satış danışmanlarımıza iletmeniz yeterli olacaktır. Satış danışmanlarımız size özel hazırlanmış teklifi size sunacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta DASK Ne Kadar Ödeme Yapar?',
      content: [
        {
          paragraph:
            'Dask sigortası tazminat ödemeleri poliçede yazan bina bedelini aşmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Deprem Sigortası Nerede Yapılır?',
      content: [
        {
          paragraph:
            'Dask sigortanızı alokasko aracılığı ile yaptırabilirsiniz. Bunun için yapmanız gereken alokasko.com üzerinde yer alan başvuru formunu doldurmaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta DASK (Poliçe) Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Dask hesaplaması Doğal Afet Sigortaları Kurumu tarafından yapılmaktadır. Kurum tarafından her yıl yapı maliyetleri hesaplanarak metrekare yapım maliyeti çıkarılır. Çıkarılan maliyet binanın metrekaresi ile çarpılarak bina bedeli hesaplanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta DASK Zorunlu Deprem Sigortası Ne Kadar?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası dairenin metrekaresi ve binanın bulunduğu adrese göre değişmektedir. Bu sebeple net bir fiyat söylemek mümkün değildir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta DASK Zorunlu Deprem Sigortası Online Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Dask sigortasını online olarak almanız mümkündür, bunun için tek yapmanız gereken alokasko.com üzerinden başvuru formunda yer alan bilgileri doldurmaktan geçer.',
          subList: null
        },
        {
          paragraph:
            'Online deprem sigortası fiyatı alarak en ucuz primlere kolayca ulaşabilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
